import styled from 'styled-components';
import { Box } from '../Box/Box.js';

const Flex = styled(Box) `
  display: flex;
`;

export { Flex };
